import React from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

//import axios from 'axios';

import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../Context';

import { TicketCreateForm } from './common/TicketForms';


export default function TicketCreate({selectedYear}){

  return (
    <>
      <div className="row">
        <h3 className="m-3">Создать обращение</h3>
      </div>
      <p className='ms-3 mb-0'>Обращения по вопросам заключения договора</p> 
      <p className='ms-3 mt-0'>По другим вопросам пожалуйста свяжитесь с АСНП ЦВКК по электронной почте <a href="mailto:labs@fsvok.ru">labs@fsvok.ru</a></p>
      <div className='m-3'>
        <TicketCreateForm
          year={selectedYear} 
        />                       
    </div> 
    </>
  )
}